import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledLink = styled(Link)(({ theme, underline, color }) => ({
    textDecoration: underline ? 'underline' : 'none',
    color: color || theme.palette.primary.mainBlue,

    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: underline ? 'underline' : 'none'
    }
}))

const BaseLink = ({ children, ...props }) => {
  return (
    <StyledLink {...props}>
      {children}
    </StyledLink>
  )
}

export default BaseLink